import { AttachmentFullViewState } from 'owa-attachment-full-data';
import AttachmentWellViewState from 'owa-attachment-well-data/lib/schema/AttachmentWellViewState';
import { ClientAttachmentId, isClientAttachmentIdEqual } from 'owa-client-ids';

function anyAttachmentInPreview(
    attachments: AttachmentFullViewState[],
    previewPaneAttachmentId: ClientAttachmentId
) {
    return attachments.some(attachment =>
        isClientAttachmentIdEqual(attachment.attachmentId, previewPaneAttachmentId)
    );
}

function isShownInPreview(
    attachmentWellViewState: AttachmentWellViewState,
    previewPaneAttachmentId: ClientAttachmentId
): boolean {
    if (previewPaneAttachmentId) {
        return (
            anyAttachmentInPreview(
                attachmentWellViewState.docViewAttachments,
                previewPaneAttachmentId
            ) ||
            anyAttachmentInPreview(
                attachmentWellViewState.imageViewAttachments,
                previewPaneAttachmentId
            )
        );
    }

    return false;
}

export default function getAllowShowMultipleRows(
    attachmentWellViewState: AttachmentWellViewState,
    previewPaneAttachmentId: ClientAttachmentId
): boolean {
    if (attachmentWellViewState.canOverrideAllowShowMultipleRows) {
        return (
            attachmentWellViewState.allowShowMultipleRows ||
            isShownInPreview(attachmentWellViewState, previewPaneAttachmentId)
        );
    }

    return attachmentWellViewState.allowShowMultipleRows;
}
